// import jwt_decode from "jwt-decode";
import { jwtDecode } from 'jwt-decode';
import React, { useEffect, useRef, useState } from "react";

import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from "react-router";
import { Link, useLocation } from 'react-router-dom';
import PasswordStrengthChecker from "../components/PasswordValidator";
import { checkEmail, createGBussinessInfo, createmgmtSubscription, numberSignUp } from "../services/apiServices.js";
import { isEmail, isEmpty, isValidPhoneNumber } from "../validators/helper.js";
import logImg from "./../components/images/Easy-MembrLogo.png";
import Signupimg from "./../landingpage/assets/images/signupimg.jpeg";
import Badge from "./../landingpage/assets/images/badge.jpg";
import { MDBAlert, MDBBtn, MDBCol, MDBContainer, MDBIcon, MDBRow } from "mdb-react-ui-kit";
import Popup from '../components/Popup';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useAnalytics } from '../hooks/useAnalytics';

const FreeSignupForm = ({ setToken }) => {
    const { trackButtonClick } = useAnalytics();
    const [error, setError] = useState({});
    const [captchaValue, setCaptchaValue] = useState(false);
    const [verror, setVError] = useState("");
    const [centredModal, setCentredModal] = useState(false);
    const [strongPassword, setstrongPassword] = useState(false);
    const [apiError, setApiError] = useState(false);
    const [signupForm, setsignupForm] = useState({
        firstname: "",
        lastname: "",
        number: "",
        email: "",
        password: "",
        confirmp: "",
        tempcaptcha: "",
    });
    const [plansData, setPlansData] = useState({});
    const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
    const otpRefs = useRef([]);
    const [resendTimer, setResendTimer] = useState(30); // seconds
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const planId = params.get('id');
    const [domain, setDomain] = useState("")
    const [capSitekey, setCapSiteKey] = useState("")
    const [notp, setNotp] = useState("");

    let capSite_id = "6LfQZGglAAAAAPPUCjiIsnyCvmGisjTTowbcFP3_"

    useEffect(() => {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const domain = urlObj.hostname;
        // console.log(domain);
        setDomain(domain)
    }, []);

    console.log(planId)
    const navigate = useNavigate();
    let validateForm = (e) => {
        e.stopPropagation();
        console.log("Validating form...");
        let errors = {};
        if (isEmpty(signupForm.firstname)) {
            errors.firstname = "First name cannot be empty.";
        }

        if (isEmpty(signupForm.lastname)) {
            errors.lastname = "Last name cannot be empty.";
        }

        if (isEmpty(signupForm.password)) {
            errors.passwordstrong = "Password cannot be empty.";
        } else if (!strongPassword.istrong) {
            errors.passwordstrong = "Please enter a strong password.";
        } else if (signupForm.password !== signupForm.confirmp) {
            errors.confirmp = "Passwords do not match.";
        }

        if (!captchaValue) {
            errors.tempcaptcha = "Please complete the captcha.";
        }
        if (isEmpty(signupForm.email)) {
            errors.email = "Email cannot be empty.";
        } else if (!isEmail(signupForm.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (isEmpty(signupForm.number)) {
            errors.number = "Mobile number cannot be empty.";
        } else if (!isValidPhoneNumber(signupForm.number)) {
            errors.number = "Please enter a valid mobile number.";
        }
        // if (isEmpty(signupForm.email) && isEmpty(signupForm.number)) {
        //     setVError("Please provide at least an email or mobile number.");
        //     errors.contact = "Please provide at least an email or mobile number.";
        // } else {
        //     if (!isEmpty(signupForm.email) && !isEmail(signupForm.email)) {
        //         errors.email = "Please enter a valid email address.";
        //     }

        //     if (!isEmpty(signupForm.number) && !isValidPhoneNumber(signupForm.number)) {
        //         errors.number = "Please enter a valid mobile number.";
        //     }
        // }

        return isEmpty(errors) ? true : errors;
    };


    const submitHandler = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const updates = {
            firstname: signupForm.firstname,
            lastname: signupForm.lastname,
            email: signupForm.email,
            password: signupForm.password,
            through: "signup",
            number: signupForm.number,
            isnumberverified: !signupForm?.number ? false : true,
            isemailverified: false,
        };
        let saverep = await createGBussinessInfo(updates);
        if (saverep === "false") {
            setApiError(true)
            return;
        }
        let jsOBj = await saverep.json();
        setToken(jsOBj.token);
        await setUserSession(jsOBj.userInfo);
        await createsubscription(jsOBj?.userInfo?.gymid);
        await trackButtonClick("FreeSignup", "Staff_Signup", "staff", {});
    };
    function setPasswordStatus(tflag) {
        setstrongPassword(tflag);
    }
    function updateForm(value) {
        return setsignupForm((prev) => {
            return { ...prev, ...value };
        });
    }
    async function setUserSession(userInfo) {
        localStorage.setItem("loggedUserInfo", JSON.stringify(userInfo));
    }
    async function createsubscription(gymid) {
        let modules = {
            smsintergration: true,
            whatsappintegration: true,
            isfreetrail: true,
            lifetimefree: false,
        };

        let updateObj = {
            planid: planId,
            gymid: gymid,
            amount: 0,
            payamount: 0,
            currency: "INR",
            response: {},
            ptype: 1,
            subscriptionfrequency: 1,
            autopay: true,
            coupon: null,
            addons: modules,
            extramonths: 0,
            paylater: false,
            planextend: 0,
            extenddays: 0,
        }
        console.log(updateObj);
        const reqObj = await createmgmtSubscription(updateObj);
        console.log(reqObj.json());
        let url = "/bInfo?value=true";
        // if (filterPlan.name == "Member Management") {
        //     url = `/bInfo?value=true`;
        // } else if (filterPlan.name == "Class Management") {
        //     url = "/classesbusiness?value=true";
        // }
        setTimeout(() => {
            window.location.href = url;
        }, 2000)
    }
    async function serverSumit(updates) {
        updateForm({ email: updates.email });
        if (await checkingEmail(updates.email)) {
            let saverep = await createGBussinessInfo(updates);
            if (saverep === "false") {
                setApiError(true)
                return;
            }
            let jsOBj = await saverep.json();
            await createsubscription(jsOBj?.userInfo?.gymid);
            console.log(jsOBj.token);
            setToken(jsOBj.token);
            await setUserSession(jsOBj.userInfo);
        }
    }
    function responseGmail(resp) {
        console.log("response from gmail..");
        console.log(resp);
        let data = jwtDecode(resp.credential);
        const uniqueId = generateUniqueKey(8);
        console.log(data);
        const updates = {
            email: data.email,
            password: uniqueId,
            through: "google",
            number: "",
            isemailverified: true,
            isnumberverified: false,
        };
        serverSumit(updates);
    }
    // console.log(domain);

    function generateUniqueKey(length) {
        const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let uniqueKey = '';
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            uniqueKey += characters.charAt(randomIndex);
        }
        return uniqueKey;
    }

    useEffect(() => {
        let CLIENT_ID = "68288337026-6p3096b5r2ukcpvbvggtrgsinp72eegd.apps.googleusercontent.com";
        if (domain == "easymembr.zencruz.com" || domain == "easymembr-beta.zencruz.com") {
            CLIENT_ID = "102702637040-eau4e3o86jeoorqtveosi9fggnkduc7j.apps.googleusercontent.com";
        } else if (domain == "www.easymembr.com" || domain == "easymembr.com" || domain == "app.easymembr.com" || domain == "beta.easymembr.com") {
            CLIENT_ID = "102702637040-5o3s1v3v4dv3vndpo3pr3r3tic04npq1.apps.googleusercontent.com"
        }
        // console.log(CLIENT_ID);
        setCapSiteKey(capSite_id)

        /* global google*/
        google.accounts.id.initialize({
            client_id: CLIENT_ID + "",
            callback: responseGmail,
            context: "signup",
        });

        google.accounts.id.renderButton(document.getElementById("signinDiv"),
            { theme: "outline", size: "large" }
        );
    }, [domain, plansData]);

    function verifyCaptchaCallback(resp) {
        console.log("Respons for captcha");
        console.log(resp);
        if (!resp) {
            setCaptchaValue(false);
        }
        else {
            console.log("true");
            setCaptchaValue(true);
        }
    }

    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setIsPasswordVisible((prevState) => !prevState);
    };
    async function checkingEmail(email) {
        // if (localStorage.getItem("loggedUserInfo")) {
        //     return true;
        // }
        let id = "1";
        let obj = {
            email: email,
        }
        const res = await checkEmail(id, obj);
        const resObj = await res.json();
        console.log(resObj)
        if (resObj?.error) {
            setError({ email: "Email already exists." });
            return false;
        } else {
            setError({});
            return true;
        }
    }
    const handleOtpChange = (e, index) => {
        const value = e.target.value.replace(/[^0-9]/g, "");

        if (value) {
            const newOtp = [...otpDigits];
            newOtp[index] = value;
            setOtpDigits(newOtp);

            // Move to next input
            if (index < otpDigits.length - 1) {
                otpRefs.current[index + 1]?.focus();
            }
        }
    };
    const handleOtpKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            e.preventDefault();

            const newOtp = [...otpDigits];

            if (otpDigits[index]) {
                // Clear current box
                newOtp[index] = "";
                setOtpDigits(newOtp);
            } else if (index > 0) {
                // Move back and clear
                otpRefs.current[index - 1]?.focus();
                newOtp[index - 1] = "";
                setOtpDigits(newOtp);
            }
        } else if (e.key === "ArrowLeft" && index > 0) {
            otpRefs.current[index - 1]?.focus();
        } else if (e.key === "ArrowRight" && index < otpDigits.length - 1) {
            otpRefs.current[index + 1]?.focus();
        }
    };
    useEffect(() => {
        if (resendTimer === 0) return;
        const timer = setInterval(() => setResendTimer((prev) => prev - 1), 1000);
        return () => clearInterval(timer);
    }, [resendTimer]);

    const handleVerifyOTP = (e) => {
        const enteredOTP = otpDigits.join("");
        if (notp == "") {
            setVError("Your OTP has expired. Please request a new one to continue.");
        } else if (enteredOTP !== notp) {
            setVError("Invalid OTP.Please try again.");
        }
        else {
            setVError("OTP verified Sucessfully. ");
            submitHandler(e);
        }
    };

    const otpfield = async () => {
        const response = await numberSignUp({ phone: signupForm?.number, value: true });
        let resData = await response.json();
        console.log(resData);
        if (resData.status !== 200) {
            setVError(resData.status === 400 ? "Please try again." : "The mobile number is already registered. Please continue to login.");
        }
        else {
            setVError("OTP Sent Sucessfully");
            setNotp(resData.otp);
            setCentredModal(true);
            setResendTimer(30)
            setOtpDigits(Array(6).fill(""));
            otpRefs.current.forEach((input) => { if (input) input.value = ""; });
            setTimeout(() => { otpRefs.current[0]?.focus(); }, 100);
            setTimeout(() => { setNotp(""); }, 300000)
        }
    }

    const handleSignup = (e) => {
        let noerrors = validateForm(e);
        console.log(noerrors);
        if (noerrors === true) {
            if (!signupForm?.number) {
                submitHandler(e);
            } else if (!notp) {
                otpfield(e)
            } else {
                setCentredModal(true);
            }
        } else {
            setError(noerrors);
        }
    };
    return (
        <React.Fragment>

            <div className='main_container min-h-100'>
                <MDBContainer className='d-flex flex-column min-h-100 justify-content-center mob-d-block'>
                    <MDBRow className='justify-content-center mob-container'>
                        <MDBCol size='10' className='signup_container shadow-3'>
                            <MDBRow>
                                <MDBCol sm={12} md={5} lg={5} xl={5} className='signup-left mob-d-none'>
                                    <img src={Signupimg} />
                                </MDBCol>
                                <MDBCol sm={12} md={7} lg={7} xl={7} className='p-0'>
                                    <div className='signup_content position-relative'>
                                        <div className='signup_header '>
                                            <div className='logo_section square border-end border-secondary pe-1 me-3'>
                                                <img src={logImg} alt="" />
                                            </div>
                                            <div className='bussiness_section'>
                                                <h4 className='m-0'>Sign Up</h4>
                                                <p className='m-0'>For 30 Days free trial </p>
                                            </div>

                                            <div className='freebadge'>
                                                <img src={Badge} alt="" />
                                            </div>
                                        </div>
                                        <div className='signup_body py-4'>
                                            <MDBRow>
                                                <MDBCol sm={12} md={6} className=''>
                                                    <div className="mb-2">
                                                        <label className="form-label m-0">First Name<span className="text-danger">*</span></label>
                                                        <input type="text"
                                                            className="form-control form-control-lg" placeholder="First Name" name="s"
                                                            onChange={(e) => updateForm({ firstname: e.target.value })} value={signupForm.firstname}
                                                            required />
                                                        {error.firstname && (
                                                            <>
                                                                <p className="clr-red">{error.firstname}</p>
                                                            </>
                                                        )}
                                                    </div>
                                                </MDBCol>
                                                <MDBCol sm={12} md={6} className=''>
                                                    <div className="mb-2">
                                                        <label className="form-label m-0">Last Name<span className="text-danger">*</span></label>
                                                        <input type="text"
                                                            className="form-control form-control-lg" placeholder="Last Name" name="s"
                                                            onChange={(e) => updateForm({ lastname: e.target.value })} value={signupForm.lastname}
                                                            required />
                                                        {error.lastname && (
                                                            <>
                                                                <p className="clr-red">{error.lastname}</p>
                                                            </>
                                                        )}
                                                    </div>

                                                </MDBCol>
                                                <MDBCol sm={12} md={6} className=''>
                                                    <div className="mb-2">
                                                        <label className="form-label m-0">Mobile Number<span className="text-danger">*</span></label>
                                                        {/* <input type="text"
                                                            className="form-control form-control-lg"
                                                            placeholder="Mobile Number"
                                                            onChange={(e) => { updateForm({ number: e.target.value }); setNotp("") }}
                                                            value={signupForm.number}
                                                        // disabled
                                                        /> */}
                                                        <PhoneInput
                                                            className=" New_business_input gym-input d-flex select_country"
                                                            defaultCountry="IN"
                                                            placeholder="Mobile Number"
                                                            value={signupForm.number}
                                                            // disabled={userExist}
                                                            // onInput={(e) => e.target.value = e.target.value.slice(0, 15)}
                                                            onChange={(value) => { updateForm({ number: value }); setNotp("") }}
                                                        />
                                                        {error.number && (
                                                            <>
                                                                <p className="clr-red">{error.number}</p>
                                                            </>
                                                        )}
                                                    </div>

                                                </MDBCol>
                                                <MDBCol sm={12} md={6} className=''>
                                                    <div className="mb-2">
                                                        <label className="form-label m-0">E-mail ID<span className="text-danger">*</span></label>
                                                        <input type="email"
                                                            className="form-control form-control-lg" placeholder="Email" name="email"
                                                            onChange={(e) => updateForm({ email: e.target.value })} value={signupForm.email}
                                                            required />
                                                        {error.email && (
                                                            <>
                                                                <p className="clr-red">{error.email}</p>
                                                            </>
                                                        )}
                                                    </div>

                                                </MDBCol>
                                                <MDBCol sm={12} md={6} className='password-input'>
                                                    <div className="mb-2">
                                                        <PasswordStrengthChecker
                                                            setPasswordInput={updateForm}
                                                            setPasswordStatus={setPasswordStatus}
                                                        />
                                                        {error.passwordstrong && (
                                                            <>
                                                                <p className="clr-red">{error.passwordstrong}</p>
                                                            </>
                                                        )}
                                                    </div>
                                                </MDBCol>

                                                <MDBCol sm={12} md={6}>
                                                    <div className="mb-2">
                                                        <label className="form-label  mb-0">Confirm Password<span className="text-danger">*</span></label>
                                                        <div className="IconContainer">
                                                            <input
                                                                type={isPasswordVisible ? "text" : "password"}
                                                                className="form-control form-control-lg" placeholder="Confirm Password"
                                                                onChange={(e) => updateForm({ confirmp: e.target.value })} value={signupForm.confirmp}
                                                                required />
                                                            <MDBIcon fas icon={isPasswordVisible ? "eye-slash" : "eye"} className="inputIcon" onClick={togglePasswordVisibility} />

                                                        </div>
                                                        {error.confirmp && (
                                                            <>
                                                                <p className="clr-red">{error.confirmp}</p>
                                                            </>
                                                        )}
                                                    </div>

                                                </MDBCol>

                                                <MDBCol size='12'>
                                                    <div className="mb-3">
                                                        <ReCAPTCHA
                                                            className=" w-100 recapthca "
                                                            sitekey={"6LfQZGglAAAAAPPUCjiIsnyCvmGisjTTowbcFP3_"}
                                                            onChange={
                                                                // (e) =>
                                                                verifyCaptchaCallback
                                                                // ({ captcha: e.target.value })
                                                            }
                                                            theme="light"
                                                            size="large"
                                                        />
                                                        {error.tempcaptcha && (
                                                            <>
                                                                <p className="clr-red">{error.tempcaptcha}</p>
                                                            </>
                                                        )}
                                                    </div>

                                                </MDBCol>

                                                <MDBCol sm={12} md={6}>
                                                    <div className="mb-3">
                                                        <div id="signinDiv" className="google-email">

                                                        </div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol sm={12} md={6}>
                                                    <div className="d-grid">
                                                        <button className=" lp_fillbtn signbtn" onClick={async (e) => { if (await checkingEmail(signupForm?.email)) { handleSignup(e) } }}>Sign up</button>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                        </div>
                                        <div className='signup_footer text-center'>
                                            <p className="mb-0 mt-3"><span className="text-dark me-2 ">Already have an account ?</span> <Link to="/login" className="px-0 login-link"> Login</Link></p>
                                        </div>

                                    </div>
                                </MDBCol>
                            </MDBRow>
                        </MDBCol>

                    </MDBRow>
                </MDBContainer>
            </div>

            <div className="back-to-home">
                <Link to={-1}>
                    <MDBBtn floating>
                        <MDBIcon className='backbtn' fas icon="arrow-left" />
                    </MDBBtn>
                </Link>
            </div>

            {/* -------------------------------------------------------------------------------------------------------------------------------------------------- */}
            {centredModal && (<>
                <Popup
                    title="Mobile Number Verification"
                    ptype="modal-md"
                    style=""
                    content={
                        <div className='text-center'>
                            <p>We've sent a One Time Password (OTP) to your mobile number <br />
                                <strong>{signupForm?.number || "+91XXXXXXXXXX"}</strong>
                            </p>

                            <p className="mb-3">Please enter the 6-digit OTP below to verify your number.</p>

                            <div className="d-flex justify-content-center gap-2 mb-3">
                                {[...Array(6)].map((_, index) => (
                                    <input
                                        key={index}
                                        type="text"
                                        maxLength={1}
                                        className="form-control text-center"
                                        style={{ width: "40px", fontSize: "1.2rem" }}
                                        value={otpDigits[index]}
                                        onChange={(e) => handleOtpChange(e, index)}
                                        onKeyDown={(e) => handleOtpKeyDown(e, index)}
                                        ref={(el) => (otpRefs.current[index] = el)}
                                    />
                                ))}
                            </div>

                            <p className="text-muted">
                                Resend OTP in <strong>{resendTimer > 0 ? `00:${resendTimer.toString().padStart(2, '0')}` : <label onClick={() => otpfield()} className='button-link fw-600 text-primary fs-14px'>Now</label>}</strong>
                            </p>

                            <MDBBtn block className="mt-2" onClick={(e) => handleVerifyOTP(e)}>
                                Verify OTP
                            </MDBBtn>
                        </div>
                    }
                    handleClose={() => setCentredModal(false)}
                />
            </>
            )}
            {verror &&
                <MDBAlert
                    color={verror.includes('Sucess') ? 'success' : 'danger'}
                    autohide
                    position='top-center'
                    delay={5000}
                    appendToBody
                    open={verror}
                    onClose={() => { setVError(null) }}
                    style={{ zIndex: 9999 }} // Add this line
                >
                    {verror}
                </MDBAlert>}

        </React.Fragment >
    );
};

export default FreeSignupForm;
